<template>
  <ColumnChart
    :xAxis="chart.xAxis"
    :series="chart.series"
    :customStyles="chart.customStyles"
  />
</template>

<script>
import ColumnChart from 'components/charts/ColumnChart'

export default {
  name: 'CustomStylesChartSample',
  components: {
    ColumnChart
  },
  data () {
    return {
      chart: {
        xAxis: {
          categories: [2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007]
        },
        series: [
          {
            name: 'Installation',
            color: '#03bbd4',
            data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
          },
          {
            name: 'Manufacturing',
            color: '#f7a35c',
            data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
          }
        ],
        customStyles: {
          color: '#666',
          fontFamily: 'Nunito Sans',
          fontSize: 10,
          fontWeight: 'bold',
          fontStyle: 'italic'
        }
      }
    }
  }
}
</script>
